export default "<p>joke-upvote works!</p>\n"